module.exports = __webpack_public_path__ + "static/media/1.639ab5c4.JPG";